import { performRequest } from "./nuxtApp.js";
import { clientOptions } from "#nuxt-graphql-middleware/client-options";
export function useGraphqlQuery(...args) {
  const [name, variables, fetchOptions, graphqlCaching, overrideClientContext] = typeof args[0] === "string" ? [
    args[0],
    args[1],
    args[2]?.fetchOptions,
    args[2]?.graphqlCaching,
    args[2]?.clientContext
  ] : [
    args[0].name,
    args[0].variables,
    args[0].fetchOptions,
    args[0].graphqlCaching,
    args[0].clientContext
  ];
  const globalClientContext = clientOptions && clientOptions.buildClientContext ? clientOptions.buildClientContext() : {};
  return performRequest(
    "query",
    name,
    variables || {},
    fetchOptions || {},
    globalClientContext || {},
    overrideClientContext || {},
    graphqlCaching || {}
  );
}
